import type { LinkItemsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { LinkItemsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface LinkItemsInput {
  Source: string;
  Targets: string[];
}

export const useLinkItems = createMutationHook({
  name: 'linkItems',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.linkedItem.link.mutationOptions({ onSuccess }),
  mapInput: (input: LinkItemsInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.linkedItem.linkedItems.queryKey(),
    // COI-471 parity: Apollo twin also evicts every linkable entity family
    // (linking changes each side's linked-items tab / counts).
    trpc.frontend.acceptance.pathKey(),
    trpc.frontend.action.pathKey(),
    trpc.frontend.appetite.pathKey(),
    trpc.frontend.control.pathKey(),
    trpc.frontend.controlGroup.pathKey(),
    trpc.frontend.document.pathKey(),
    trpc.frontend.indicator.pathKey(),
    trpc.frontend.internalAuditEntity.pathKey(),
    trpc.frontend.issue.pathKey(),
    trpc.frontend.obligation.pathKey(),
    trpc.frontend.obligationChange.pathKey(),
    trpc.frontend.risk.pathKey(),
  ],
  // Consumers ignore the payload — surface an empty link set.
  mapResponse: (): LinkItemsMutation => ({
    linkItems: {
      __typename: 'LinkItemsOutput',
      Links: [],
    },
  }),
  graphqlDocument: LinkItemsDocument,
  graphqlVariables: (input: LinkItemsInput) => ({
    Source: input.Source,
    Targets: input.Targets,
  }),
  evictFields: [
    'linked_item',
    'control',
    'action',
    'issue',
    'internal_audit_entity',
    'internal_audit_entity_aggregate',
    'appetite',
    'risk',
  ],
});
